export abstract class IStorage
{
    abstract get(name: string, defaultValue: string): string;
    abstract set(name: string, value: string): void;
    abstract del(name: string): void;
}